import gql from 'graphql-tag';

export const ADMIN_LOGOUT = gql`
    query {
        adminLogout
    },
`;
